/* eslint-disable @typescript-eslint/ban-ts-comment */
import { useEffect, useMemo, useRef, useState } from "react";
import * as THREE from "three";
import { useThree } from "@react-three/fiber";
//@ts-ignore
import { PerspectiveCamera } from "@react-three/drei";
import { camTarget } from "@layouts/sidebar-layout/sidebar-layout.js";
import { useGLTF } from "@common/hooks/useGLTF.js";
import { useLocation } from "react-router-dom";
import { positions as residences } from "@data/positions/positions_res.js";
import { positions as location } from "@data/positions/positions_res.js";

const RenderSceneCamera = ({ activeId }: { activeId: number }) => {
  const { pathname } = useLocation();
  const { scene, gl, invalidate } = useThree();
  const secondaryCamera = useRef<THREE.PerspectiveCamera>(null);

  const [positions, setPositions] = useState([]);

  useEffect(() => {
    if (pathname === "/residences") {
      setPositions(residences);
    } else if (pathname === "/the-location") {
      setPositions(location);
    }
  }, [pathname]);

  const testPositions = useMemo(() => {
    const array = [];
    for (let i = 0; i < positions.length; i += 4) {
      array.push(
        new THREE.Vector3(positions[i], positions[i + 1], positions[i + 2]),
      );
    }
    return array;
  }, [positions]);

  useEffect(() => {
    if (!testPositions[activeId]) return;
    console.log(testPositions[activeId]);
    const position = testPositions[activeId];
    if (secondaryCamera.current) {
      secondaryCamera.current.position.copy(position);
      secondaryCamera.current.lookAt(camTarget);
      secondaryCamera.current.updateProjectionMatrix();
      invalidate();
    }
  }, [activeId, gl, invalidate, scene, testPositions]);

  return (
    <>
      <Occlusion />
      <PerspectiveCamera
        makeDefault={true}
        ref={secondaryCamera}
        fov={50}
        aspect={window.innerWidth / window.innerHeight}
        near={0.1}
        far={1000}
      />
    </>
  );
};

const Occlusion = () => {
  const { nodes } = useGLTF("assets/models/selector.glb");

  return (
    <>
      <group position={[0.12, 0, -0.6]}>
        <group scale={0.0001}>
          <mesh
            renderOrder={-999900}
            geometry={nodes["mesh_0"].geometry}
          >
            <meshBasicMaterial
              colorWrite={false}
              depthTest={true}
              depthWrite={true}
              color="#DAD6C1"
            />
          </mesh>
        </group>
      </group>
    </>
  );
};

export default RenderSceneCamera;
